/* Attach the spark burst to the Offers link(s) in the nav.

   Matched by href rather than label so it survives a rename and works in both
   the desktop menu and the mobile drawer. The label is wrapped so it can be
   animated independently of the dots. */
(function () {
  var MATCH = '/offers';
  var DOTS = 8;

  function decorate(a) {
    if (a.dataset.spark) return;
    a.dataset.spark = '1';
    a.classList.add('cro-spark');

    /* Wrap the existing label so the pop animation has its own element and
       does not fight whatever the theme already puts inside the link. */
    if (!a.querySelector('.cro-spark__t')) {
      var t = document.createElement('span');
      t.className = 'cro-spark__t';
      while (a.firstChild) t.appendChild(a.firstChild);
      a.appendChild(t);
    }

    var box = document.createElement('span');
    box.className = 'cro-spark__b';
    box.setAttribute('aria-hidden', 'true');

    var ring = document.createElement('span');
    ring.className = 'cro-spark__r';
    box.appendChild(ring);

    for (var i = 0; i < DOTS; i++) {
      var d = document.createElement('span');
      d.className = 'cro-spark__d';
      d.style.setProperty('--a', (i * (360 / DOTS) + 14) + 'deg');
      d.style.setProperty('--d', (i * 40) + 'ms');
      box.appendChild(d);
    }
    a.appendChild(box);
  }

  function run() {
    var links = document.querySelectorAll('a[href*="' + MATCH + '"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].closest('header, nav, .hdt-header, .hdt-menu, .hdt-drawer')) {
        decorate(links[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
})();
